import { FC, SVGProps } from "react";

const ChevronRight: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M13.2499 6.91016C12.7493 7.4107 12.7493 8.22216 13.2499 8.7227L25.0288 20.5017L13.2533 32.2772C12.7527 32.7777 12.7527 33.5892 13.2533 34.0897C13.7538 34.5903 14.5653 34.5903 15.0658 34.0897L27.7502 21.4054C28.2507 20.9048 28.2507 20.0934 27.7502 19.5928L26.8448 18.6874L26.8431 18.6891L15.0641 6.91016C14.5619 6.40962 13.7504 6.40962 13.2499 6.91016Z" />
    </svg>
  );
};

export default ChevronRight;
